import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UrlService } from 'src/app/miscellaneous/url.service';
import { DataService } from "../../../../services/data.service";
import { Files } from "../../../../miscellaneous/files";

@Component({
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss'],
  providers: [UrlService, Files]
})
export class DocumentPreviewComponent implements OnInit {

  data: any | undefined;
  page: string | undefined;
  endpoint: string | undefined;
  src: string | undefined = "";
  id: string | undefined | false;
  model?: { title: string } = { title: "" };

  constructor(
    private serviceUrl: UrlService,
    private dataService: DataService,
    private file: Files
  ) {

  }

  ngOnInit(): void {

    this.id = this.serviceUrl.getUrlId(this.page);
    if (this.id) {
      this.dataService.getData(this.data.endpoint + "/" + this.id).subscribe(model => {
        this.model = model;
        if (model.extension === "pdf") {
          this.src = "/assets/img/icon-pdf.png";
        } else if (this.file.isImage(model.mimeType)) {
          //this.file.getBlob( this.endpoint,  Number(this.id)).subscribe(data => this.src = data);
          this.file.getSrc(this.data.endpoint, Number(this.id)).subscribe(data => this.src = data);
        }

      });
    }

  }

  download(title: string) {
    this.file.download(this.data.endpoint, Number(this.id), title);
  }

  preview() {
    this.file.preview(this.data.endpoint, Number(this.id));
  }

}
